module.exports = __webpack_public_path__ + "img/loading.01110b89.gif";